import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { RU_SERVICES } from "@/data/ru-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ru/services";
const C = RU_SERVICES;

export const Route = createFileRoute("/ru/services")({
  head: () => ({
    meta: [
      { title: ctaTitle("Юридические услуги в Бангкоке на русском | NYC Legal", "/ru/services", "th")},
      { name: "description", content: ctaDesc("Русскоязычный юридический отдел в Бангкоке: нотариус, перевод, апостиль, брак, визы, Work Permit. Send your documents for a free eligibility check.", "/ru/services", "th")},
      { property: "og:title", content: ctaTitle("Юридические услуги на русском в Бангкоке | NYC Legal", "/ru/services", "th")},
      { property: "og:description", content: ctaDesc("Комплексное сопровождение русскоязычных клиентов в Таиланде.", "/ru/services", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ru_RU" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/services" },
          { hreflang: "en", path: "/en/services" },
          { hreflang: "zh", path: "/zh/services" },
          { hreflang: "ja", path: "/ja/services" },
          { hreflang: "ko", path: "/ko/services" },
          { hreflang: "ru", path: "/ru/services" },
          { hreflang: "x-default", path: "/services" },
        ],
        "/services",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — Russian Desk", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "RU"], inLanguage: "ru",
        priceRange: "฿1,500–฿50,000",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "ru",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Главная", item: `${SEO_SITE}/ru` },
          { "@type": "ListItem", position: 2, name: "Услуги", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
